import React from 'lib/react';
import {
  EVGrid, EVIconButton, EVCircledClear, EVClear, makeStyles,
} from 'lib/components';
import PropTypes from 'prop-types';
import { useTranslation } from 'lib/translation';
import useMediaQuery from 'hooks/useMediaQuery';

const useStyles = makeStyles((theme) => ({
  clearFilterButton: {
    width: 'fit-content',
    color: theme.evPalette.charcoal[500],
    padding: '0',
    borderRadius: '4px',
    justifyContent: 'flex-start',
    '&:focus': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
  mobileClearButton: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
    color: 'white',
    backgroundColor: '#B4BAC7',
    borderRadius: '20px',
    padding: '2px 2px 2px 6px',
  },
  desktopClearButton: {
    display: 'flex',
    alignItems: 'center',
    '&>.myev-MuiSvgIcon-root': {
      height: '30px',
      width: '30px',
    },
  },
}));
function ClearButton(props) {
  const { id, handleClear, ...rest } = props;
  const { t } = useTranslation();
  const isMobile = useMediaQuery(640);
  const classes = useStyles();
  return (
    <EVIconButton
      id={id}
      className={classes.clearFilterButton}
      onClick={((e) => { e.stopPropagation(); handleClear(); })}
      onMouseDown={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      {...rest}
    >
      {isMobile ? (
        <EVGrid className={classes.mobileClearButton}>
          {t('common__clear')}
          <EVClear />
        </EVGrid>
      ) : (
        <EVGrid className={classes.desktopClearButton}>
          <EVCircledClear />
        </EVGrid>
      )}
    </EVIconButton>
  );
}

ClearButton.propTypes = {
  id: PropTypes.string.isRequired,
  handleClear: PropTypes.func.isRequired,
};

export default ClearButton;
